import {
  NumberFormatValues,
  NumericFormat,
  NumericFormatProps,
  SourceInfo,
} from 'react-number-format';
import { ChangeEvent } from 'react';

export type InputNumberFormatProps = Omit<NumericFormatProps<HTMLInputElement>, 'value'> & {
  inputRef?: (el: HTMLInputElement) => void | undefined;
  onChange: InputNumberFormatChangeHandler;
  name: string;
  hasThousandSeparator?: boolean;
};

export type InputNumberFormatChangeHandler = (
  e: ChangeEvent<HTMLInputElement>,
  values: NumberFormatValues
) => void;

export type { NumberFormatValues };

export default function InputNumberFormat({
  inputRef,
  onChange: onValueChange,
  hasThousandSeparator = true,
  ...props
}: InputNumberFormatProps): JSX.Element {
  const handleValueChange = (values: NumberFormatValues, sourceInfo: SourceInfo): void => {
    // note: the DOM event on sourceInfo is sometimes null
    onValueChange(sourceInfo.event as ChangeEvent<HTMLInputElement>, values);
  };

  return (
    <NumericFormat
      {...props}
      getInputRef={inputRef}
      onValueChange={handleValueChange}
      allowNegative={false}
      thousandSeparator={hasThousandSeparator}
    />
  );
}
